<template>
  <div id="financial-profile-items" class="bg-wht">
    <div class="row">
      <div class="col-xs-12">
        <div>
          <loader v-if="loading"/>
          <div v-else-if="!loading && crud">
            <div class="col-xs-12 col-sm-6">
              <div class="form-group">
                <label for="name" class="form-label">Label</label>
                <input id="name" type="text" class="form-control" v-model="entity.label"/>
              </div>
              <div class="form-group">
                <label for="key" class="form-label">Key Field</label>
                <input id="key" type="text" class="form-control" v-model="entity.keyField"/>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6">
              <div class="form-group">
                <label for="default-value" class="form-label">Default Value</label>
                <input id="default-value" type="text" class="form-control" v-model="entity.defaultValue"/>
              </div>
              <div class="pull-right" style="margin-top:26px;">
                <div class="btn btn-success sq" @click="save">
                  Save
                </div>
                <div class="btn btn-danger sq" @click="reset">
                  Clear
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="!loading && !crud">
            <div class="col-xs-12 col-sm-6">
              <div class="form-group" v-for="item in items">
                <label :for="item.keyField" class="form-label">{{ item.label }}</label>
                <input :id="item.keyField" type="text" class="form-control" v-model="keyFields[item.keyField]"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!loading && crud">
      <vue-table
        :tableData="items"
        :fields="itemFields"
        :show-edit="true"
        :show-delete="true"
        @table-edit-request="edit"
        @table-delete-request="remove"
      />
      <div class="btn btn-primary sq" @click="go">
        Test With Defaults
      </div>
    </div>
  </div>
</template>
<script>
  import api from '../../../../api/endpoints'
  import event from '../../../../event'
  import Loader from '../../../helpers/Loader'
  import VueTable from '../../../helpers/VueTable'
  import ReportMixin from '../../../../mixins/ReportMixin'
  export default {
    name: 'ReportParameters',
    components: { Loader, VueTable },
    mixins: [ ReportMixin ],
    props: {
      parentId: {
        type: Number,
        required: true
      },
      filename: {
        type: String,
        required: true
      },
      crud: {
        type: Boolean,
        default: true,
        required: false
      }
    },
    data () {
      return {
        items: [],
        entity: {
          id: null,
          document: null,
          keyField: null,
          label: null,
          defaultValue: null
        },
        loading: true,
        itemFields: [
          { header: 'Label', prop: 'label' },
          { header: 'Key', prop: 'keyField' },
          { header: 'Default', prop: 'defaultValue' }
        ],
        entityName: 'document-parameter',
        keyFields: {}
      }
    },
    computed: {
      reportParams () {
        const params = { filename: this.filename }
        this.items.forEach(({ keyField, defaultValue }) => { params[keyField] = this.crud ? defaultValue : this.keyFields[keyField] })
        return params
      }
    },
    methods: {
      go () {
        this.generateReport(this.reportParams)
      },
      reset () {
        this.entity = {
          id: null,
          document: null,
          keyField: null,
          label: null,
          defaultValue: null
        }
      },
      edit ({ item }) {
        this.entity = item
      },
      remove ({ item }) {
        this.$http.delete(api.DELETE_ADMIN_ENTITY(this.entityName, item.id))
          .then(() => this.removeFromTable(item.id))
          .catch(console.log)
      },
      save () {
        const url = this.entity.id ? api.UPDATE_ADMIN_ENTITY(this.entityName, this.entity.id) : api.CREATE_ADMIN_ENTITY(this.entityName)
        const method = this.entity.id ? 'put' : 'post'
        this.$http[method](url, { ...this.entity, document: this.parentId })
          .then(({data}) => {
            if (method === 'post') {
              this.items.push(data)
            } else {
              const item = this.items.find(({id}) => id === this.entity.id)
              if (item) {
                for (let prop in item) {
                  item[prop] = data[prop]
                }
              }
            }
            this.reset()
          })
      },
      removeFromTable (_id) {
        const index = this.items.findIndex(({id}) => id === _id)
        if (index > -1) {
          this.items.splice(index, 1)
        }
      },
      setKeyFields () {
        this.items.forEach(({keyField, defaultValue}) => this.$set(this.keyFields, keyField, defaultValue || ''))
      },
      getItems () {
        if (this.parentId) {
          this.$http.get(api.GET_ENTITIES(this.entityName), { params: { document: this.parentId } })
            .then(({data}) => {
              this.items = data
              this.setKeyFields()
            })
            .catch(err => {
              console.log(err)
              event.$emit('toast', { type: 'error', message: 'Unable to Load Items' })
            }).then(() => { this.loading = false })
        }
      }
    },
    watch: {
      parentId: {
        handler: 'getItems',
        immediate: true
      }
    }
  }
</script>
<style></style>



// WEBPACK FOOTER //
// src/modules/admin/components/Report/ReportParameters.vue